import { render, staticRenderFns } from "./DescriptionCard.vue?vue&type=template&id=b160486c&scoped=true&"
import script from "./DescriptionCard.vue?vue&type=script&lang=js&"
export * from "./DescriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionCard.vue?vue&type=style&index=0&id=b160486c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b160486c",
  null
  
)

export default component.exports